// Heroku - Edit in Vercel to include Heroku backend link
export const API_URL = process.env.REACT_APP_API_URL;

// Local
// export const API_URL = "http://localhost:8000/"
// export const API_URL = "http://159.89.197.234:8000/"
// export const API_URL = "http://ama_backend_c:8000/"

export const CLOUD_NAME = "dwlebi9l0"
export const RE_DIGIT = new RegExp(/^\d+$/);